import * as Actions from '../../actions';

const initialState = { data: null };

const listProcessorReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_PROCESSOR_LIST_DETAILS:
            return { ...state, data: { ...action.payload } };
        default:
            return state;
    }
};

export default listProcessorReducer;
